<template>
    <div class="bank-card fixed-pop">
        <div class="content">
            <el-radio-group v-model="creditCardIndex" class="bank-list">
                <el-radio v-for="(item, index) in dataList" :label="index" :key="index" class="con" @change="confirmClick(item)">
                    <img src="@/assets/images/pay/other_pay_credit_card2.svg"/>{{item.name}}

                    <!--todo 編輯卡片名稱-->
                    <button class="edit-name" @click.stop="editName(item)">
                        <img src="@/assets/images/edit2.svg">
                    </button>

                    <span class="no">
                        *{{item.card4No}}
                    </span>
                    <button class="delete-btn" @click.stop="deleteCard(item)">
                        <i class="el-icon-close"/>
                    </button>
                </el-radio>
            </el-radio-group>

            <div class="text-center mt-4 mb-3">
                <el-button round @click="addPayToken">
                    綁定其他信用卡
                </el-button>
            </div>
        </div>
        <comm-dialog :value="isShowDialog"
                     :outerContent="'確定刪除此張信用卡？'"
                     :mainContent="mainContent"
                     @result="onDialogResult"/>

        <EditNameDialog :value="isShowEditNameDialog"
                        :icon="require('@/assets/images/dialog_ticket.svg')"
                        :isTextBox="true"
                        :textMaxlength="'10'"
                        :textType="'text'"
                        :outerContent="'編輯卡片名稱'"
                        :defaultTextContent="editNameDialogText"
                        :key="editNameDialogKey"
                        @result="onEditNameDialogResult"/>
    </div>
</template>

<script>
import CommDialog from "@/components/CommDialog";
import EditNameDialog from "@/components/CommDialog";
import * as constDefine from "@/store/constDefine";
export default {
    name: "CreditCard",
    props: {
        list: { type:Array, default: () => [] },
    },
    components: {
        CommDialog,

        EditNameDialog,
    },
    data() {
        return {
            creditCardIndex: -1,
            isShowDialog: false,
            dataList: [],
            mainContent: '',
            selectItem: {},
            oinPayName: constDefine.OinPayName,
            //編輯卡片名稱彈窗
            isShowEditNameDialog: false,
            editNameDialogText: "",
            editNameDialogKey: 0,
        }
    },
    created() {
        this.dataList = JSON.parse(JSON.stringify(this.list))
        this.dataList.forEach((item, index) => {
            if(item.isDefault) {
                this.creditCardIndex = index
            }
        })
    },
    methods: {
        confirmClick(item) {
            this.$emit('triggerEvent', {
                event: "updateDefault",
                selectItem: item,
            })
        },
        cancel() {
            //點空白處關閉
            this.$emit('triggerEvent', {
                event: "cancel",
            })
        },
        deleteCard(item) {
            this.isShowDialog = true

            if (this.dataList.length > 1) {
                //設定多張卡片時
                this.mainContent = ""
            } else {
                //只有設定一張卡片
                this.mainContent = `將會無法使用${this.oinPayName}`
            }

            this.selectItem = item
        },
        addPayToken() {
            let self = this
            //不可綁定超過三張時提示
            if (self.dataList.length >= 3) {
                self.$public.showNotify("信用卡綁定不可超過三組", false);
                return false;
            } else {
                self.$emit('triggerEvent', {
                    event: "addPayToken",
                })
            }
        },
        onDialogResult(isSure) {
            let self = this
            self.isShowDialog = false;
            if(isSure) {
                self.$emit('triggerEvent', {
                    event: "deletePayToken",
                    selectItem: self.selectItem,
                })
            }
        },
        //編輯信用卡名稱
        editName(item){
            let self = this

            self.selectItem = item
            self.editNameDialogText = item.name
            self.editNameDialogKey++
            self.isShowEditNameDialog = true
        },
        onEditNameDialogResult(isSure, eventType, content) {
            let self = this

            if(isSure) {
                if(content === "") {
                    self.$public.showNotify("請輸入卡片名稱", false);
                } else {
                    self.$emit('triggerEvent', {
                        event: "updatePayTokenName",
                        selectItem: self.selectItem,
                        content: content,
                    })

                    self.isShowEditNameDialog = false;
                }
            } else {
                self.isShowEditNameDialog = false;
            }
        },
    }
}
</script>
<style lang="less" src="@/less/pullDownClose.less"/>